export default {
  computed: {
    totalGross() {
      let totalGross = 0;

      if (this.form.amount) {
        totalGross += parseFloat(this.form.amount);
      }
      if (this.form.cleaning_fee) {
        totalGross += parseFloat(this.form.cleaning_fee);
      }
      if (this.form.extras) {
        totalGross += parseFloat(this.form.extras);
      }

      return totalGross;
    },
    totalExtra() {
      return this.form.extras;
    },
    totalPayment() {
      return this.form.payment;
    },
    toPay() {
      const cityTax = parseFloat(this.form.city_tax || 0);
      let total = this.totalGross + cityTax;
    
      if (this.form.source.name === 'airbnb') {
        total -= parseFloat(this.form.ota_fee || 0);
      }
    
      total -= parseFloat(this.totalPayment || 0);

      return parseFloat(total.toFixed(2));
    }
  }
}
